import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleCaseWithoutUnderscorePipe',
})
export class TitleCaseWithoutUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const words = value.replace(/_/g, ' ').split(' ');

    const titleCasedText = words
      .filter(word => !!word)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');

    return titleCasedText;
  }
}
